module.exports = __webpack_public_path__ + "media/src/img/hero-bg-mob-d62b1dbe13137f9499edc6e630aab740.png";